const size = {
    width: 51,
    height: 59,
};

export const markerIcon = (marker, customMapIconUrl) => {
    return {
        url: customMapIconUrl || marker.map_icon,
        scaledSize: {
            width: size.width,
            height: size.height,
        },
    };
};